/**
 * @file SN normalisation for cross-system matching (CLIENT mirror).
 *
 * Byte-for-byte mirror of `functions/lib/sn-match.js` — see that file for the
 * full rationale. The Czech distributor prefixes 'S' to serial numbers in
 * Abra (~90% of the time), so an Abra "SLJ0V6NY2LR" must match a typed /
 * Meraki "LJ0V6NY2LR". Strips a single leading 'S' (case-insensitive) so both
 * sides land on the same key.
 *
 * The client can't import the Cloud Functions bundle, so this is hand-mirrored.
 * The two copies MUST stay aligned — `tests/invariants.test.js` asserts they
 * produce identical output (drift → the device-history serial variants the
 * client queries would disagree with the materialise join / reconciler).
 */

/**
 * @param {string|null|undefined} sn
 * @returns {string|null}
 */
export function normaliseSnForMatch(sn) {
  if (sn == null) return null;
  const upper = String(sn).trim().toUpperCase();
  if (!upper) return null;
  return upper.length > 1 && upper.startsWith('S') ? upper.slice(1) : upper;
}
